import { render, staticRenderFns } from "./PTT.vue?vue&type=template&id=507f1010&scoped=true&"
import script from "./PTT.vue?vue&type=script&lang=ts&"
export * from "./PTT.vue?vue&type=script&lang=ts&"
import style0 from "./PTT.vue?vue&type=style&index=0&id=507f1010&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f1010",
  null
  
)

export default component.exports